import React from 'react';
import logo from '@assets/egovex_final_logo.png';

interface EgovexLogoProps {
  size?: number;
  className?: string;
}

const EgovexLogo: React.FC<EgovexLogoProps> = ({ size = 36, className = '' }) => {
  return (
    <img 
      src={logo}
      alt="Egovex Logo"
      width={size}
      height={size}
      className={`${className} rounded-lg object-cover`}
    />
  );
};

export default EgovexLogo;
